import { FormConfiguration } from "../../shared/crud/form";
import { CommunicationAlertEntity } from "./communicationAlert.entity";
import { messages } from "../messages";

export function buildFormConfiguration(): FormConfiguration<CommunicationAlertEntity> {
  return {
    __fieldOrder: [
      "limiteAvisoDisponibilidad",
      "emailAvisoDispo",
    ],
    limiteAvisoDisponibilidad: {
      messages: {
        label: messages.limiteAvisoDisponibilidad,
        helpText: messages.limiteAvisoDisponibilidadHelperText,
      },
    },
    emailAvisoDispo: {
      messages: {
        label: messages.emailAvisoDispo,
        helpText: messages.emailAvisoDispoHelperText,
      },
    },
  };
}
